var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 151,
    viewBox: "0 0 164 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5532,
    cy: 74.1489,
    r: 23.5532,
    fill: "url(#paint0_linear_1938_1234)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.486 53.6458C97.2004 48.6149 88.3069 48.8511 80.2556 48.8511C66.7658 48.8511 55.8301 37.9154 55.8301 24.4255C55.8301 10.9357 66.7658 0 80.2556 0C93.7455 0 104.681 10.9357 104.681 24.4255C104.681 31.8635 105.638 40.2324 111.445 44.88L113.674 46.664C120.214 51.8982 129.6 51.1943 137.959 50.6483C138.493 50.6134 139.032 50.5957 139.575 50.5957C153.065 50.5957 164 61.5314 164 75.0212C164 88.5111 153.065 99.4468 139.575 99.4468C138.952 99.4468 138.335 99.4235 137.724 99.3777C129.406 98.7545 120.053 98.0223 113.54 103.235L111.498 104.869C105.615 109.578 104.681 118.081 104.681 125.617C104.681 139.107 93.7455 150.043 80.2556 150.043C66.7658 150.043 55.8301 139.107 55.8301 125.617C55.8301 112.127 66.7658 101.192 80.2556 101.192C88.1949 101.192 96.9471 101.38 103.146 96.4188L109.216 91.5604C113.979 87.7487 115.149 81.1213 115.149 75.0212C115.149 68.8138 113.989 62.0514 109.143 58.1726L103.486 53.6458Z",
    fill: "url(#paint1_linear_1938_1234)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1938_1234",
    x1: 23.5532,
    y1: 50.5957,
    x2: 23.5532,
    y2: 97.7021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EE11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10CF46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1938_1234",
    x1: 109.915,
    y1: 0,
    x2: 109.915,
    y2: 150.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EE11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10CF46"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVec);
export default __webpack_public_path__ + "static/media/vec.1fbef67df66f7455b5e1494eec0daf2c.svg";
export { ForwardRef as ReactComponent };